import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./content";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("tria-lang") || "pt");
  useEffect(() => {
    localStorage.setItem("tria-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-AO" : "en";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: content[lang] }}>{children}</LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const useSeo = (page) => {
  const { t } = useLang();
  const [title, desc] = t.seo[page];
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
  }, [title, desc]);
};
